import { AiChatOption, MessageType } from './ai.model';

export interface joinRoom {
  receiver_id?: string;
  chat_id?: string;
}

export interface joinRoomResponse {
  chat_id: string;
  status: string;
  chat_type?: 'HYBRID' | 'AI_BOOKING_OR_SUPPORT' | string;
}

export interface sendMessage {
  chat_id: string;
  content?: string | null;
  media?: Array<string>;
  enquiry_id?: number;
  type: string;
}

export interface leaveChat {
  chat_id: string;
}

/** Normalizes API/socket timestamp fields onto `created_at`. */
export function resolveChatCreatedAt(
  source?: Partial<receive> | Record<string, unknown> | null
): string | undefined {
  if (!source) {
    return undefined;
  }

  const record = source as Record<string, unknown>;
  const raw =
    record['created_at'] ?? record['createdAt'] ?? record['created_at_utc'];

  if (raw == null || raw === '') {
    return undefined;
  }

  if (typeof raw === 'number' && Number.isFinite(raw)) {
    const milliseconds = raw > 1e12 ? raw : raw * 1000;
    return new Date(milliseconds).toISOString();
  }

  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    return trimmed || undefined;
  }

  return undefined;
}

export interface receive {
  content: string | null;
  created_at?: string;
  createdAt?: string;
  id: string | number;
  media?: Array<string> | null;
  help_guide_slug?: string;
  type?: string;
  message_type?: MessageType | string;
  agent_name?: string;
  agent_id?: string;
  sender_id: string;
  sender_name: string;
  sender_photo: string | null;
  chat_id?: string;
  chat_type?: 'HYBRID' | 'AI_BOOKING_OR_SUPPORT' | string;
  status?: string;
  options?: AiChatOption[];
  selected_option?: AiChatOption | null;
}

export interface receiveResponse {
  list: receive[];
  total: number;
}
